import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { getDemoData } from 'utils/helpers';
import { selectIsDemo } from 'store/selectors/uiSelectors';

/**
 * Central hook for tutorial/demo PII masking (admin-only toggle in Topbar).
 * @returns {{ isDemo: boolean, mask: (key: string, value: unknown) => unknown }}
 */
export function useDemoMask() {
  const isDemo = useSelector(selectIsDemo);

  const mask = useCallback(
    (key, value) => {
      if (!isDemo) return value;
      const demoValue = getDemoData(key);
      return demoValue !== '' ? demoValue : value;
    },
    [isDemo],
  );

  return { isDemo, mask };
}
